import * as actionTypes from '../actionTypes';

const initialState = {
  allProducts: [],
  pagination: {},
  paginationLink: '',
  currentProduct: {},
  userCurrentProduct: {},
  userCurrentProductTypesList: {},
  similarProducts: [],
  foundProducts: [],
  foundPagination: {},
  userProducts: [],
  userProductsPagination: {},
  productsStatuses: {},
  searchIsLoading: false,
  isLoading: false,
  productIsCreating: false,
  userProductStatusChanging: false,
  userProductStatusChangingSucc: false,
  userProductDeleting: false,
  userProductEditing: false,
  complaintStatus: false,
};

// eslint-disable-next-line consistent-return,no-unused-vars
const checkProductChanges = (state, product) => {
  if (state.userProductsPagination.current_page === 1) {
    const productInList = state.userProducts.find((el) => el.id === product.id);
    if (productInList) {
      return {
        ...state,
        userProducts: state.userProducts
          .map((el) => (el.id === product.id ? product : el)),
      };
    }
    if (product.was_recently_created) {
      const newArray = [product, ...state.userProducts];
      const currentArray = newArray.slice(0, state.userProductsPagination.per_page);
      const pagination = {
        ...state.userProductsPagination,
        total: newArray.length,
      };
      return {
        ...state,
        userProducts: currentArray,
        userProductsPagination: pagination,
      };
    }
  }
  return { ...state };
};

const productReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_ALL_PRODUCTS_START:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.GET_ALL_PRODUCTS_SUCCESS:
      return {
        ...state,
        allProducts: payload.showMore
          ? [...state.allProducts, ...payload.data]
          : payload.data,
        pagination: payload.meta.pagination,
        isLoading: false,
      };
    case actionTypes.GET_ALL_PRODUCTS_FAIL:
      return {
        ...state,
        isLoading: false,
      };

    case actionTypes.GET_CURRENT_PRODUCT_START:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.GET_CURRENT_PRODUCT_SUCCESS:
      return {
        ...state,
        currentProduct: payload,
        isLoading: false,
      };
    case actionTypes.GET_CURRENT_PRODUCT_FAIL:
      return {
        ...state,
        isLoading: false,
      };
    case actionTypes.REMOVE_CURRENT_PRODUCT:
      return {
        ...state,
        currentProduct: {},
      };

    case actionTypes.GET_SIMILAR_PRODUCTS_START:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.GET_SIMILAR_PRODUCTS_SUCCESS:
      return {
        ...state,
        similarProducts: payload,
        isLoading: false,
      };
    case actionTypes.GET_SIMILAR_PRODUCTS_FAIL:
      return {
        ...state,
        isLoading: false,
      };

    case actionTypes.GET_SEARCH_ALL_PRODUCTS_START:
      return {
        ...state,
        searchIsLoading: true,
      };
    case actionTypes.GET_SEARCH_ALL_PRODUCTS_SUCCESS:
      return {
        ...state,
        foundProducts: payload.data,
        foundPagination: payload.meta.pagination,
        searchIsLoading: false,
      };
    case actionTypes.GET_SEARCH_ALL_PRODUCTS_FAIL:
      return {
        ...state,
        searchIsLoading: false,
      };

    case actionTypes.CREATE_PRODUCT_START:
      return {
        ...state,
        productIsCreating: true,
      };
    case actionTypes.CREATE_PRODUCT_SUCCESS:
      return {
        ...state,
        productIsCreating: false,
      };
    case actionTypes.CREATE_PRODUCT_FAIL:
      return {
        ...state,
        productIsCreating: false,
      };

    case actionTypes.GET_USER_PRODUCTS_START:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.GET_USER_PRODUCTS_SUCCESS:
      return {
        ...state,
        userProducts: payload.data,
        userProductsPagination: payload.meta.pagination,
        productsStatuses: payload.statuses,
        isLoading: false,
      };
    case actionTypes.GET_USER_PRODUCTS_FAIL:
      return {
        ...state,
        isLoading: false,
      };

    case actionTypes.UPDATE_USER_PRODUCT_STATUS_START:
      return {
        ...state,
        userProductStatusChanging: true,
        userProductStatusChangingSucc: false,
      };
    case actionTypes.UPDATE_USER_PRODUCT_STATUS_SUCCESS:
      return {
        ...state,
        userProductStatusChanging: false,
        userProductStatusChangingSucc: true,
      };
    case actionTypes.UPDATE_USER_PRODUCT_STATUS_FAIL:
      return {
        ...state,
        userProductStatusChanging: false,
        userProductStatusChangingSucc: false,
      };

    case actionTypes.DELETE_USER_PRODUCT_START:
      return {
        ...state,
        userProductDeleting: true,
      };
    case actionTypes.DELETE_USER_PRODUCT_SUCCESS:
      return {
        ...state,
        userProductDeleting: false,
      };
    case actionTypes.DELETE_USER_PRODUCT_FAIL:
      return {
        ...state,
        userProductDeleting: false,
      };

    case actionTypes.EDIT_USER_PRODUCT_START:
      return {
        ...state,
        userProductEditing: true,
      };
    case actionTypes.EDIT_USER_PRODUCT_SUCCESS:
      return {
        ...state,
        userProductEditing: false,
      };
    case actionTypes.EDIT_USER_PRODUCT_FAIL:
      return {
        ...state,
        userProductEditing: false,
      };

    case actionTypes.GET_CURRENT_USER_PRODUCT_START:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.GET_CURRENT_USER_PRODUCT_SUCCESS:
      return {
        ...state,
        userCurrentProduct: payload.data,
        userCurrentProductTypesList: payload.types,
        isLoading: false,
      };
    case actionTypes.GET_CURRENT_USER_PRODUCT_FAIL:
      return {
        ...state,
        isLoading: false,
      };
    case actionTypes.REMOVE_CURRENT_USER_PRODUCT:
      return {
        ...state,
        userCurrentProduct: {},
      };
    case actionTypes.SEND_PRODUCT_COMPLAINT_START:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.SEND_PRODUCT_COMPLAINT_SUCCESS:
      return {
        ...state,
        complaintStatus: payload.success,
        isLoading: false,
      };
    case actionTypes.SEND_PRODUCT_COMPLAINT_FAIL:
      return {
        ...state,
        isLoading: false,
      };
    case actionTypes.SEND_PRODUCT_COMPLAINT_DISCARD:
      return {
        ...state,
        complaintStatus: false,
      };
    case actionTypes.CHANGE_PRODUCT_INFO:
      return checkProductChanges(state, payload);
    case actionTypes.GET_CURRENT_PRODUCT_BID:
      return {
        ...state,
        // eslint-disable-next-line max-len
        currentProduct: { ...state.currentProduct, auction_bids: [payload, ...state.currentProduct?.auction_bids] },
      };
    default:
      return state;
  }
};

export default productReducer;
